var __WEBPACK_NAMESPACE_OBJECT__ = kolibriCoreAppGlobal.coreVue.composables.useUser;